import { useCallback, useState } from 'react';
import { MIME_TO_EXTENSION } from '@/postulation_form/components/attached-files/constants';

export const useInputFileValidation = ({
  validateSize = null, // Tamaño en bytes
  onFileSelect = null,
  fileTypes = []
} = {}) => {
  const [validationState, setValidationState] = useState(
    fileTypes.reduce((acc, fileType) => {
      acc[fileType] = {
        file: null,
        error: '',
        nameInput: '',
        buttonUploader: ''
      };
      return acc;
    }, {})
  );

  const handleChange = useCallback(
    (params) => {
      const { inputFilename, fileContent, buttonUploader } = params;

      if (!fileContent) return;

      if (validateSize && fileContent.size > validateSize) {
        setValidationState((prev) => ({
          ...prev,
          [inputFilename]: {
            ...prev[inputFilename],
            error: `Archivo muy grande (máx: ${validateSize / 1024 / 1024}MB)`,
            file: null,
            buttonUploader
          }
        }));
        return;
      }

      const { name, type: mimeType } = fileContent;
      const fileExtension = name.split('.').pop().toLowerCase();
      const validExtensions = MIME_TO_EXTENSION[mimeType] || [];
      const isValidExtension = validExtensions.includes(fileExtension);
      if (!isValidExtension) {
        setValidationState((prev) => ({
          ...prev,
          [inputFilename]: {
            ...prev[inputFilename],
            error: 'Archivo inválido.',
            file: null,
            buttonUploader
          }
        }));
        return;
      }

      setValidationState((prev) => ({
        ...prev,
        [inputFilename]: {
          ...prev[inputFilename],
          error: '',
          file: fileContent,
          nameInput: inputFilename,
          buttonUploader
        }
      }));

      onFileSelect?.(inputFilename, fileContent, buttonUploader);
    },
    [validateSize, onFileSelect]
  );

  const reset = useCallback((fileType = null) => {
    if (fileType) {
      setValidationState((prev) => ({
        ...prev,
        [fileType]: { file: null, error: '', nameInput: '', buttonUploader: '' }
      }));
    } else {
      setValidationState((prev) =>
        Object.keys(prev).reduce((acc, key) => {
          acc[key] = { file: null, error: '', nameInput: '', buttonUploader: '' };
          return acc;
        }, {})
      );
    }
  }, []);

  return { validationState, handleChange, reset };
};
